// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bfj_a bie_bk bie_bl bie_bo","SwipeLeftToClose--animating":"bfj_b"};